import {SET_IS_MEDIA_PLAYING} from '../actiontypes';

export function setIsMediaPlaying(isMediaPlaying) {
	return {
		type: SET_IS_MEDIA_PLAYING,
		isMediaPlaying
	};
}
